<template>
  <div id="app">
    <v-app id="inspire">
      <altaciklama></altaciklama>
      <onaydialog ref="onaydialog"></onaydialog>

      <v-content>
        <v-layout v-if="listegorunum" row wrap>


          <v-flex>
            <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
              <v-tabs-slider></v-tabs-slider>
              <v-tab href='#0'>
                {{$t("tab_general")}}
              </v-tab>
              <v-tab-item :id="'0'" style="width:100%; height:500px;">
                <v-layout row="" wrap="">
                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat class="white--text">

                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-text-field hide-details="" disabled="" v-model="ManageInfo.UserInfo.Email"
                              label="E-Posta">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field hide-details="" v-model="ManageInfo.UserInfo.AdSoyad" :label="$t('Name_Surname_label')">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field hide-details="" v-model="ManageInfo.UserInfo.GSM" :label="$t('Mobilphonenumber_label')">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-select :items="locales" :label="$t('Default-Language')" hide-details=""
                              v-model="ManageInfo.UserInfo.DefaultDil" item-text="title" @change="dildegistir()"
                              item-value="locale"></v-select>
                          </v-flex>

                        </v-layout>

                      </v-card-actions>

                    </v-card>
                  </v-flex>


                </v-layout>



              </v-tab-item>

              <v-tab href='#1'>
                {{ $t('Authorizations') }}
              </v-tab>

              <v-tab-item :id="'1'" style="width:100%; height:500px;">
                <v-layout row="" wrap="">
                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card-actions>

                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-layout justify-end>
                              <v-btn @click="satirekle()" flat color="info">
                                <v-icon>add_box</v-icon> {{ $t('Add') }}
                              </v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout justify-end>
                              <v-divider></v-divider>
                            </v-layout>
                          </v-flex>



                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-list>

                                <template>
                                  <v-layout row wrap>


                                    <v-flex xs12 sm2 md2>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{ $t('User-Type') }} </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm3 md3>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{ $t('Code') }}</v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm4 md4>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{$t('Title_label')}}</v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>





                                    <v-flex xs12 sm2 md2>
                                      <v-layout justify-center="" align-center>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout justify-center="" align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column justify-center="" align-center>
                                                      {{$t('Status')}}
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex xs12 sm1 md1>
                                      <v-layout justify-center="" align-center>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout justify-center="" align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column justify-center="" align-center>
                                                      {{ $t('Process') }}
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>




                                  </v-layout>
                                  <v-divider></v-divider>
                                </template>

                                <template v-for="item in yetkilist">
                                  <v-layout row wrap v-bind:key="item.MusteriKod">

                                    <v-flex xs12 sm2 md2>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      <v-chip v-if="item.UserTip=='1'">
                                                        <v-avatar class="white--text red">A</v-avatar>
                                                        {{ $t('Admin') }}
                                                      </v-chip>
                                                      <v-chip v-if="item.UserTip=='0'">
                                                        <v-avatar class="white--text info">S</v-avatar>
                                                        {{ $t('Standart') }}
                                                      </v-chip>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm3 md3>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{item.MusteriKod}}</v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md4>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{item.MusteriUnvan}}</v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex xs12 sm1 md2>
                                      <v-layout justify-end="" align-center row fill-height="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row align-center fill-height="" justify-end="">

                                                <v-chip v-if="item.Aktif==true">
                                                  <v-avatar class="white--text green">A</v-avatar>
                                                   {{ $t('Active') }}
                                                </v-chip>
                                                <v-chip v-if="item.Aktif==false">
                                                  <v-avatar class="white--text red">P</v-avatar>
                                                  {{ $t('Passive') }}
                                                </v-chip>

                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex xs12 sm1 md1>
                                      <v-layout justify-end="" align-center row fill-height="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row align-center fill-height="" justify-end="">
                                                <v-flex ma-2 xs12 sm4 md3>
                                                  <v-btn :disabled="!item.Yetki==1" small icon class="mx-0"
                                                    @click="detayagit(item)">
                                                    <v-icon large color="green">edit</v-icon>
                                                  </v-btn>
                                                </v-flex>
                                                <v-flex ma-2 xs12 sm4 md3>
                                                  <v-btn :disabled="!item.Yetki==1" small icon class="mx-0"
                                                    @click="listesil(item)">
                                                    <v-icon large color="red">delete</v-icon>
                                                  </v-btn>
                                                </v-flex>

                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider :key="item.id"></v-divider>
                                </template>

                              </v-list>
                            </v-flex>
                          </v-layout>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-flex>


                </v-layout>



              </v-tab-item>

              <v-tab href='#2'>
                Default Şİrket
              </v-tab>
              <v-tab-item :id="'2'" style="width:100%; height:500px;">
                <v-layout row="" wrap="">
                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card-actions>

                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-layout justify-end>
                              <v-btn @click="yeniDefaultSirketDialogAc()" flat color="info">
                                <v-icon>add_box</v-icon> &nbsp; Yeni Ekle  
                              </v-btn>                                      

                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout justify-end>
                              <v-divider></v-divider>
                            </v-layout>
                          </v-flex>



                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-list>
                                <template>
                                  <v-layout row wrap>

                                    <v-flex xs12 sm2 md3>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      <span class="font-weight-bold"> {{$t('Main-Company')}}</span></v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md2>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      <span class="font-weight-bold"> {{ $t('Default-Current-Company') }} </span>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md2>

                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout justify-center="" align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column justify-center="" align-center>
                                                    <span class="font-weight-bold"> {{ $t('Default-Coper-Company') }} </span>
                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>

                                    </v-flex>
                                    <v-flex xs12 sm2 md3>

<v-card flat="">
  <v-list-tile>
    <v-list-tile-content>
      <v-layout justify-center="" align-center>
        <v-flex>
          <v-list-tile-sub-title>
            <v-layout column justify-center="" align-center>
              <span class="font-weight-bold"> {{ 'Default Muhasebe Şirket' }} </span>
            </v-layout>
          </v-list-tile-sub-title>
        </v-flex>
      </v-layout>
    </v-list-tile-content>
  </v-list-tile>
</v-card>

</v-flex>
<v-flex xs12 sm2 md2>
                                      <v-layout justify-center="" align-center>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout justify-center="" align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column justify-center="" align-center>

                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                  <v-divider></v-divider>
                                </template>

                                <template v-for="item in defaultsirketlist">
                                  <v-layout row wrap v-bind:key="item.MusteriKod">

                                    <v-flex xs12 sm2 md3>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{item.MusteriKod}} - {{item.MusteriUnvan}}</v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md2>
                                      <v-layout column="" align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column align-center>
                                                      {{item.DefaultCariSirket}}-{{getCariSirket(item)}}</v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md2>
                                      <v-layout column="" row justify-center align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column row justify-center full-width align-center>
                                                      {{item.DefaultCoperSirket}}-{{getCoperSirket(item)}} </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md3>
                                      <v-layout column="" row justify-center align-start>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout align-center>
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout column row justify-center full-width align-center>
                                                      {{item.muhasebeSirket}}-{{getMuhasebeSirket(item)}} </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm2 md2>
                                      <v-layout justify-end="" align-center row fill-height="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row align-center fill-height="" justify-end="">
                                                <v-flex xs12 sm12 md12>
                                                  <v-btn small icon class="mx-0" @click="defaultSirketSil(item)">
                                                    <v-icon color="red">delete</v-icon>
                                                  </v-btn>
                                                  <v-btn small icon class="mx-0" @click="defaultSirketDialogAc(item)">
                                                    <v-icon color="green">edit</v-icon>
                                                  </v-btn>
                                                </v-flex>


                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider :key="item.id"></v-divider>
                                </template>

                              </v-list>
                            </v-flex>
                          </v-layout>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-flex>

                </v-layout>



              </v-tab-item>
            </v-tabs>
          </v-flex>




        </v-layout>


      </v-content>


      <navi v-model="drawer"></navi>

      <v-dialog v-model="dialoglisteduzenle" persistent max-width="400px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialogbaslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>
            <v-layout wrap>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex pa-1 xs12 sm12 md12>
                        <v-layout justify-space-between column>
                          <v-select :disabled="yenimi" hide-details :label="$t('Select-Your-Main-Company')" item-value="MusteriKod"
                            persistent-hint :items="AnaSirketler" item-text="MusteriUnvan" v-model="AnaSirket" bottom>
                          </v-select>
                        </v-layout>
                      </v-flex>
                      <v-flex pa-1 xs6 sm6 md6>
                        <v-layout justify-space-between column>
                          <v-radio-group hide-details v-model="kullanicitipi" :label="$t('User-Type')" column>
                            <v-radio :label="$t('Standart')" :value="0"></v-radio>
                            <v-radio :label="$t('Admin')" :value="1"></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>
                      <v-flex pa-1 xs6 sm6 md6>
                        <v-layout justify-space-between column>
                          <v-checkbox hide-details v-model="aktifmi" :label="$t('Active')"></v-checkbox>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click="sirketduzenleiptal()">{{$t('Cancel')}}</v-btn>
            <v-btn color="info" flat v-if="dialogguncellebtn" @click="satirguncelle()">Satırı Güncelle</v-btn>
            <v-btn color="info" v-if="dialogeklebtn" flat @click="listeyeekle()">{{ $t('Add') }}</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDefaultSirket" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ $t('Choose-Default-Company') }}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>
            <v-layout wrap>

              <v-card-actions>
                <v-layout row wrap>

                  <v-flex pa-1 xs12 sm12 md12>

                    <v-select hide-details :label="$t('Choose-Current-Company')" item-value="SirketKodu" persistent-hint
                      :items="CariSirketler" item-text="SirketAdi" v-model="secilenSirketKayit.DefaultCariSirket"
                      bottom>
                    </v-select>

                  </v-flex>


                  <v-flex pa-1 xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <v-select hide-details :label="$t('Choose-Coper-Company')" item-value="SirketNo" persistent-hint
                        :items="CoperSirketler" item-text="SirketKod" v-model="secilenSirketKayit.DefaultCoperSirket"
                        bottom>
                      </v-select>
                    </v-layout>
                  </v-flex>

                  <v-flex pa-1 xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <v-select hide-details label="Muhasebe Şirket Seçiniz" item-value="CompanyID" persistent-hint
                        :items="MuhasebeSirketler" item-text="CompanyShortName" v-model="secilenSirketKayit.DefaultMuhasebeSirket"
                        bottom>
                      </v-select>
                    </v-layout>
                  </v-flex>


                </v-layout>
              </v-card-actions>

            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click.native="dialogDefaultSirket=false">{{$t('Cancel')}}</v-btn>
            <v-btn color="info" @click="defaulSirketKaydet()" flat>{{$t("save_button")}}</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogyeniDefaultSirket" persistent max-width="400px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Add-New-Default-Company') }} </v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>
            <v-layout wrap>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout row wrap>

                      <v-flex pa-1 xs12 sm12 md12>
                        <v-select hide-details @change="sirketgetir()" :label="$t('Select-Your-Main-Company')"
                          item-value="MusteriKod" persistent-hint :items="AnaSirketler" item-text="MusteriUnvan"
                          v-model="AnaSirket" bottom>

                        </v-select>
                      </v-flex>
                      <v-flex pa-1 xs12 sm12 md12>
                        <v-layout justify-space-between column>
                          <v-select hide-details :label="$t('Choose-Current-Company')" item-value="SirketKodu" persistent-hint
                            :items="CariSirketler" item-text="SirketAdi" v-model="secilenSirketKayit.DefaultCariSirket"
                            bottom>
                          </v-select>
                        </v-layout>
                      </v-flex>


                      <v-flex pa-1 xs12 sm12 md12>
                        <v-layout justify-space-between column>
                          <v-select hide-details :label="$t('Choose-Coper-Company')" item-value="SirketNo" persistent-hint
                            :items="CoperSirketler" item-text="SirketKod"
                            v-model="secilenSirketKayit.DefaultCoperSirket" bottom>
                          </v-select>
                        </v-layout>
                      </v-flex>

                      <v-flex pa-1 xs12 sm12 md12>
                        <v-layout justify-space-between column>
                          <v-select hide-details label="Muhasebe Şirket Seçiniz" item-value="CompanyID" persistent-hint
                            :items="MuhasebeSirketler" item-text="CompanyShortName"
                            v-model="secilenSirketKayit.DefaultMuhasebeSirket" bottom>
                          </v-select>
                        </v-layout>
                      </v-flex>


                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click.native="dialogyeniDefaultSirket=false">{{$t('Cancel')}}</v-btn>
            <v-btn color="info" @click="yeniDefaultSirketKaydet()" flat>{{$t("save_button")}}</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="hidden-sm-and-down"> {{ $t('User-Transactions') }} </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="kullaniciguncelle()" flat> <span class="hidden-sm-and-down"> {{ $t('Update') }} </span>
        </v-btn>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>
            <a target="_self" v-bind:href="'#/uye/index/'">
              <v-list-tile>
                <v-list-tile-title>{{$t("cancel_button")}}</v-list-tile-title>
              </v-list-tile>
            </a>
          </v-list>
        </v-menu>


      </v-toolbar>


      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>

    </v-app>
  </div>

</template>

<script>
  import auth from '../../../../api/auth'
  import _ from 'underscore'
  import router from '../../../../router'
  import helpers from "@/components/app/customcomp/helpers.js"
  import navi from "@/components/app/account/navigator.vue"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import altaciklama from "@/components/app/account/altaciklama.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"

  import $ from '@/plugins/i18n.js'
  import {
    Trans
  } from '@/plugins/Translation'



  export default {
     data() {
        return {
      degisenKayit: -1,
      CariSirketler: [],
      CoperSirketler: [],
      MuhasebeSirketler:[],
      dialogyeniDefaultSirket: false,
      dialogDefaultSirket: false,
      secilenSirketKayit: {},
      defaultsirketlist: [],
      locale: 'tr',
      locales: [{
          locale: 'tr',
          title: 'Türkçe',
          href: 'turkey'
        },
        {
          locale: 'en',
          title: 'English',
          href: 'english'
        },
        {
          locale: 'de',
          title: 'Deutsch',
          href: 'germany'
        },
      ],
      yenimi: true,
      sirketitems: [],
      detay: false,
      listeleme: true,
      active: null,
      UserInfo: {
        AdSoyad: null,
        Deleted: null,
        Email: null,
        GSM: null,
        KullaniciAdi: null,
        Sifre: null,
        UserID: null
      },
      yetkilist: [],
      listegorunum: true,
      islem: false,
      dialoglisteduzenle: false,
      kullanicitipi: 0,
      aktifmi: false,
      dialogbaslik: null,
      dialogeklebtn: false,
      dialogguncellebtn: false,

      ManageInfo: {
        UserInfo: {
          UserID: null,
          AdSoyad: null,
          KullaniciAdi: null,
          Email: null,
          GSM: null,
          DefaultDil: null,
          Sifre: null,
          Deleted: false,
        },
        AnaSirketInfo: []
      },

      WebUserAnaSirket: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
        // Masraf: null,
        // Referans: null,
        // Bolum: null,
      },

      WebUserAnaSirket1: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
        // Masraf: null,
        // Referans: null,
        // Bolum: null,
      },

      kaydetbtn: false,
      guncellebtn: false,
      eklebtn: true,
      itemseklenen: [],
      degistirilensirket: null,
      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',
      karttipi: [{
          id: 'M',
          text: 'Master Card'
        },
        {
          id: 'VI',
          text: 'VISA'
        },
        {
          id: 'A',
          text: 'American Express'
        },
      ],
      sonkullanimAy: [{
          id: '01',
          text: '1'
        },
        {
          id: '02',
          text: '2'
        },
        {
          id: '03',
          text: '3'
        },
        {
          id: '04',
          text: '4'
        },
        {
          id: '05',
          text: '5'
        },
        {
          id: '06',
          text: '6'
        },
        {
          id: '07',
          text: '7'
        },
        {
          id: '08',
          text: '8'
        },
        {
          id: '09',
          text: '9'
        },
        {
          id: '10',
          text: '10'
        },
        {
          id: '11',
          text: '11'
        },
        {
          id: '12',
          text: '12'
        }
      ],
      sonkullanimYil: [
        '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
        '2016', '2017',
        '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
        '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041',
        '2042', '2043','2044', '2045', '2046', '2047', '2048', '2049', '2050'
      ],
      dictionary: {
        custom: {
          kartno: {
            required: () => this.$t('This-space-cannot-left-blank'),
            min: this.$t('Card-Number-Must-16-Digits')
          },

          selectkarttipi: {
            required: () => this.$t('Please-choose'),
          },
          kartcari: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanim: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanimyil: {
            required: () => this.$t('Please-choose'),
          },

        }
      },
      itemsnavi: [{
          icon: 'business',
          text: this.$t('Corporate-transactions'),
          to: 'anasirket',
        },
        {
          icon: 'people',
          text: this.$t('Member-Transactions'),
          to: 'login-uye'
        },

      ],
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      UrunKayit: {
        ID: null,
        MusteriInfo: {
          MusteriID: null,
          MusteriKod: null
        },
        UrunInfo: {
          UrunID: null
        },
        UrunAdet: 1,
        BaslangicTarih: null,
        BitisTarih: null,
        Kontor: null,
        KalanKontor: null,
        SatisTarihi: null,
        SatisTutar: 0,
        Aktif: null,
        OdemeOnay: 'false'
      },

      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,
      items: [{
          icon: 'domain',
          text: this.$t('Corporate-transactions')
        },
        {
          icon: 'contacts',
          text: this.$t('Member-Transactions')
        },
      ],

      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      }
    },
    props: {
      source: String
    },
    methods: {
      getCariSirket: function (val) {

        var musteriid = val.MusteriID

        var response = JSON.parse(window.localStorage.getItem('response'));
        var anasirket = response.MusteriDbler.filter(function (el) {
          return el.MusteriId == musteriid
        });

        if (anasirket.length == 1) {
          var sirket = anasirket[0].GenelSirketler.filter(function (el) {
            return el.SirketKodu == val.DefaultCariSirket
          });

          if (sirket.length != 0) {
            return sirket[0].SirketUnvani
          } else {
            return null
          }
        } else {
          return '-';
        }



      },
      getMuhasebeSirket:function(val){
       
console.log(val);
var musteriid = val.MusteriID

var response = JSON.parse(window.localStorage.getItem('response'));

var anasirket = response.MusteriDbler.filter(function (el) {
  return el.MusteriId == musteriid
});

if (anasirket.length == 1) {
  var sirket = anasirket[0].GenelSirketlerMuhasebe.filter(function (el) {
    return el.CompanyID == val.DefaultMuhasebeSirket
  });

  if (sirket.length == 1) {
    return sirket[0].CompanyShortName
  } else {
    return null
  }
} else {
  return '-';
}
      },
       getCoperSirket: function (val) {

        var musteriid = val.MusteriID

        var response = JSON.parse(window.localStorage.getItem('response'));

        var anasirket = response.MusteriDbler.filter(function (el) {
          return el.MusteriId == musteriid
        });

        if (anasirket.length == 1) {
          var sirket = anasirket[0].GenelSirketlerCoper.filter(function (el) {
            return el.SirketNo == val.DefaultCoperSirket
          });

          if (sirket.length == 1) {
            return sirket[0].SirketKod
          } else {
            return null
          }
        } else {
          return '-';
        }



      },
      defaultSirketSil(a) {

        this.$refs.onaydialog.open("this.$t('Are-you-sure-you-want-to-delete-this-record')", 1).then(
          sonuc => {

            if (sonuc == true) {

              var params = {
                ID: a.ID,
                UserID: a.UserID
              }

              this.$http.post(auth.API_URL + 'api/Awed/WebUserDefaultCompanyDelete', params, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {

                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true

                if (response.body.Status == true) {
                  this.setManageLoad();
                }

              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable-WebUserDefaultCompanySave'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable-WebUserDefaultCompanySave'
                  this.snackbar = true
                }
              })

            }
          });
      },

      yeniDefaultSirketKaydet() {

        var aranan = this.AnaSirket

        var varmi = this.defaultsirketlist.filter(function (el) {
          return el.MusteriKod == aranan
        });

        if (varmi.length != 1) {
      this.degisenKayit = -1
          this.secilenSirketKayit.MusteriKod = this.AnaSirket
          var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
          this.secilenSirketKayit.UserID = response2.UserInfo.UserID
        this.defaulSirketKaydet();
        } else {
          this.text1 = "Seçmiş olduğunuz kayıt listede mevcuttur, tekrar eklemezsiniz."
          this.snackbar = true
        }
      },

      sirketgetir() {
        var response = JSON.parse(window.localStorage.getItem('response'));
        var aranan = this.AnaSirket
        var anasirketim = response.MusteriDbler.filter(function (el) {
          return el.MusteriKod == aranan
        });

        if (anasirketim.length > 0) {
          this.CariSirketler = anasirketim[0].GenelSirketler
          this.CoperSirketler = anasirketim[0].GenelSirketlerCoper
          this.MuhasebeSirketler = anasirketim[0].GenelSirketlerMuhasebe
          this.secilenSirketKayit.MusteriID = anasirketim[0].MusteriId
        } else {
          this.MuhasebeSirketler = []
          this.CariSirketler = []
          this.CoperSirketler = []
        }
      },

      yeniDefaultSirketDialogAc() {
       
        var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
         console.log(manageload);
        this.AnaSirketler = manageload.AnaSirketInfo;
        this.AnaSirket = manageload.AnaSirketInfo[0].MusteriKod;// this.AnaSirketler[0].MusteriKod
        console.log(manageload.UserInfo.UserID);
        var yeni = {
          ID: null,
          MusteriID: null,
          MusteriKod: null,
          MusteriUnvan: null,
          UserID: manageload.UserInfo.UserID,
          DefaultCariSirket: null,
          DefaultCoperSirket: null,
          DefaultMuhasebeSirket:null
        }
        this.secilenSirketKayit = yeni
        this.dialogyeniDefaultSirket = true


        var response = JSON.parse(window.localStorage.getItem('response'));
        var aranan = this.AnaSirket
        var anasirketim = response.MusteriDbler.filter(function (el) {
          return el.MusteriKod == aranan
        });

        if (anasirketim.length > 0) {
          this.CariSirketler = anasirketim[0].GenelSirketler
          this.CoperSirketler = anasirketim[0].GenelSirketlerCoper
          this.MuhasebeSirketler = anasirketim[0].GenelSirketlerMuhasebe
          this.secilenSirketKayit.MusteriID = anasirketim[0].MusteriId
        } else {
          this.MuhasebeSirketler = []
          this.CariSirketler = []
          this.CoperSirketler = []
        }

      },

      setManageLoad() {
        var userparams = {
          Email: this.$route.params.id,
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          window.localStorage.removeItem('WebUserManageLoad')
          window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))
          var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
          this.defaultsirketlist = []
          response2.AnaSirketInfo.forEach(element => {
            var cariSirket = null
            var coperSirket = null
            var muhasebeSirket = null
            var id = null

            var yetkiler = response2.UserInfo.DefaultSirketList.filter(function (el) {
              return el.MusteriID == element.MusteriID
            });

            if (yetkiler.length == 1) {
              cariSirket = yetkiler[0].DefaultCariSirket
              coperSirket = yetkiler[0].DefaultCoperSirket
              muhasebeSirket = yetkiler[0].DefaultMuhasebeSirket
              id = yetkiler[0].ID

              var yeni = {
                ID: id,
                MusteriID: element.MusteriID,
                MusteriKod: element.MusteriKod,
                MusteriUnvan: element.MusteriUnvan,
                UserID: element.UserID,
                DefaultCariSirket: cariSirket,
                DefaultCoperSirket: coperSirket,
                DefaultMuhasebeSirket: muhasebeSirket
              }
              this.defaultsirketlist.push(yeni)
             
            }
          });
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          }
        })
      },

      defaulSirketListe() {

        var response = JSON.parse(window.localStorage.getItem('response'));

        var params = {
          ID: null,
          UserID: response.UserId,
        }

        this.$http.post(auth.API_URL + 'api/Awed/WebUserDefaultCompanyList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status == true) {}

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserDefaultCompanyList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserDefaultCompanyList'
            this.snackbar = true
          }
        })

      },

      defaulSirketKaydet() {

        if (this.degisenKayit != -1) {
          this.defaultsirketlist.splice(this.degisenKayit, 1, this.secilenSirketKayit);
        } else {
          this.defaultsirketlist.push(this.secilenSirketKayit)
        }

        var response = JSON.parse(window.localStorage.getItem('response'));
        var list = []

        this.defaultsirketlist.forEach(element => {
          var yeni = {
            ID: element.ID,
            UserID: response.UserId,
            MusteriID: element.MusteriID,
            DefaultCariSirket: element.DefaultCariSirket,
            DefaultCoperSirket: element.DefaultCoperSirket,
            DefaultMuhasebeSirket: element.DefaultMuhasebeSirket
          }

          list.push(yeni)
        });

        var params = list
        this.$http.post(auth.API_URL + 'api/Awed/WebUserDefaultCompanySave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage) +
            ', ayarlarınızın aktif olması için çıkış yapmanız gerekmektedir.'
          this.snackbar = true

          if (response.body.Status == true) {
            this.setManageLoad();
            this.dialogDefaultSirket = false
            this.dialogyeniDefaultSirket = false
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserDefaultCompanySave'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserDefaultCompanySave'
            this.snackbar = true
          }
        })

      },

      defaultSirketDialogAc(element) {
        this.degisenKayit = this.defaultsirketlist.indexOf(element);

        var yeni = {
          ID: element.ID,
          MusteriID: element.MusteriID,
          MusteriKod: element.MusteriKod,
          MusteriUnvan: element.MusteriUnvan,
          UserID: element.UserID,
          DefaultCariSirket: element.DefaultCariSirket,
          DefaultCoperSirket: element.DefaultCoperSirket,
          DefaultMuhasebeSirket: element.DefaultMuhasebeSirket,
        }

        this.secilenSirketKayit = yeni

        var response = JSON.parse(window.localStorage.getItem('response'));
        var anasirket = response.MusteriDbler.filter(function (el) {
          return el.MusteriId == element.MusteriID
        });

        if (anasirket.length > 0) {

          this.CariSirketler = anasirket[0].GenelSirketler
          this.CoperSirketler = anasirket[0].GenelSirketlerCoper
          this.MuhasebeSirketler = anasirket[0].GenelSirketlerMuhasebe
        } else {
          this.MuhasebeSirketler = []
          this.CariSirketler = []
          this.CoperSirketler = []
        }

        this.dialogDefaultSirket = true

      },
      dildegistir() {

        const lang = this.ManageInfo.UserInfo.DefaultDil
        const to = this.$router.resolve({
          params: {
            lang
          }
        })
        return Trans.changeLanguage(lang).then(() => {
          this.$router.push(to.location)
        })
      },
      logout() {
        auth.logout()
      },
      satirekle() {
        var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)

        this.yenimi = false;
        this.dialogbaslik = 'Yeni Satır Ekle'
        this.dialogeklebtn = true
        this.dialogguncellebtn = false
        this.dialoglisteduzenle = true;
      },

      satirguncelle() {
        var yedeklist = this.yetkilist
        var silinenkayit = null
        for (var i = 0; i < this.yetkilist.length; i++) {
          if (this.yetkilist[i].MusteriKod == this.degistirilensirket) {
            silinenkayit = this.yetkilist[i]
            this.yetkilist.splice(i, 1);
          }
        }

        var kayitvarmi = this.yetkilist.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.AnaSirket);

        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket1.MusteriID,
              MusteriKod: this.WebUserAnaSirket1.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket1.MusteriUnvan,
              UserTip: this.kullanicitipi,
              Aktif: this.aktifmi
            }
            this.yetkilist.push(yenikayit)
            this.dialoglisteduzenle = false
          } else {
            this.text1 = this.$t('The-Company-You-Want-to-Authorize-is-in-the-List.')
            this.snackbar = true
            this.yetkilist.push(silinenkayit)
          }
        } else {
          this.text1 = "Ana Şirketi Seçiniz"
          this.snackbar = true
        }


      },
      yenikullanicikaydet() {
        if (this.itemseklenen.length > 0) {
          if (this.ManageInfo.UserInfo.AdSoyad != null && this.ManageInfo.UserInfo.Email != null && this.ManageInfo
            .UserInfo
            .GSM != null) {
            this.ManageInfo.AnaSirketInfo = this.itemseklenen;
            var userparams = this.ManageInfo
            this.$http.post(auth.API_URL + 'api/Register/WebUserManageSave', userparams, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageSave'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-WebUserManageSave'
                this.snackbar = true
              }
            })
          } else {
            this.text1 = this.$t('Please-Add-User-Information')
            this.snackbar = true
          }
        } else {
          this.text1 = this.$t('Please-Add-Company')
          this.snackbar = true
        }
      },
      listesil(val) {

        for (var i = 0; i < this.yetkilist.length; i++) {
          if (this.yetkilist[i].MusteriKod == val.MusteriKod) {
            this.yetkilist.splice(i, 1);
          }
        }
      },
      listeyeekle() {


        var kayitvarmi = this.yetkilist.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.AnaSirket);

        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket1.MusteriID,
              MusteriKod: this.WebUserAnaSirket1.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket1.MusteriUnvan,
              UserTip: this.kullanicitipi,
              Aktif: this.aktifmi,

            }
            this.yetkilist.push(yenikayit)
            this.dialoglisteduzenle = false
          } else {
            this.text1 = this.$t('Record-not-included-list')
            this.snackbar = true
          }
        } else {
          this.text1 = "Ana Şirketi Seçiniz"
          this.snackbar = true
        }
      },
      detayagit(val1) {
        var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)
        this.yenimi = true;
        var kod = val1.MusteriKod
        this.kullanicitipi = val1.UserTip
        this.aktifmi = val1.Aktif
        this.degistirilensirket = val1.MusteriKod
        this.dialoglisteduzenle = true;
        this.dialogbaslik = 'Satır Güncelle'
        this.AnaSirket = String(kod)
        this.dialogeklebtn = false
        this.dialogguncellebtn = true
      },
      yenikullaniciekle() {
        var response = JSON.parse(window.localStorage.getItem('response'));
        this.AnaSirketler = response.MusteriDbler
        this.listegorunum = false
        this.islem = true;
        this.kaydetbtn = true;
        this.guncellebtn = false;
        this.eklebtn = false;
      },

      sirketduzenleiptal() {
        this.dialoglisteduzenle = false
      },
      kullaniciguncelle
    },
    beforeMount: beforeMount,
    components: {
      navi,
      referansmerkezicomp,
      masrafmerkezicomp,
      bolumcomp,
      altaciklama,
      onaydialog
    },
    watch: {
      'AnaSirket': function (value) {
        if (value != null) {
          this.AnaSirketler.forEach(element => {
            if (element.MusteriKod == value) {
              this.WebUserAnaSirket1.MusteriKod = element.MusteriKod
              this.WebUserAnaSirket1.MusteriUnvan = element.Ad
              this.WebUserAnaSirket1.MusteriID = element.MusteriID
            }
          });
        }
      },

    },
    filters: {


    },
  }

  function beforeMount() {
    var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
    this.defaultsirketlist = []
    response2.AnaSirketInfo.forEach(element => {
      var cariSirket = null
      var coperSirket = null
      var muhasebeSirket=null
      var id = null

      var yetkiler = response2.UserInfo.DefaultSirketList.filter(function (el) {
        return el.MusteriID == element.MusteriID
      });


      if (yetkiler.length == 1) {
        cariSirket = yetkiler[0].DefaultCariSirket
        coperSirket = yetkiler[0].DefaultCoperSirket
        muhasebeSirket=yetkiler[0].DefaultMuhasebeSirket
        id = yetkiler[0].ID
        var yeni = {
          ID: id,
          MusteriID: element.MusteriID,
          MusteriKod: element.MusteriKod,
          MusteriUnvan: element.MusteriUnvan,
          UserID: element.UserID,
          DefaultCariSirket: cariSirket,
          DefaultCoperSirket: coperSirket,
          DefaultMuhasebeSirket: muhasebeSirket
        }
        this.defaultsirketlist.push(yeni)
      }
    });

    var userparams = {
      Email: this.$route.params.id,
    }

    this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.ManageInfo = response.body
      var yetkibilgisieklenmislist = []
      response.body.AnaSirketInfo.forEach(element => {
        var kayitvarmi = response2.AnaSirketInfo.map(function (e) {
          return e.MusteriKod;
        }).indexOf(element.MusteriKod);

        var kayit = {
          Aktif: element.Aktif,
          Bolum: element.Bolum,
          Masraf: element.Masraf,
          MusteriID: element.MusteriID,
          MusteriKod: element.MusteriKod,
          MusteriUnvan: element.MusteriUnvan,
          Referans: element.Referans,
          UserTip: element.UserTip,
          Yetki: response2.AnaSirketInfo[kayitvarmi].UserTip
        }
        yetkibilgisieklenmislist.push(kayit);
      });

      this.yetkilist = yetkibilgisieklenmislist
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserManageLoad'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserManageLoad'
        this.snackbar = true
      }
    })


  }

  function kullaniciguncelle() {
    this.ManageInfo.AnaSirketInfo = this.yetkilist
    var userparams = this.ManageInfo
    this.$http.post(auth.API_URL + 'api/Register/WebUserManageUpdate', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      if (response.body.Status == true) {

        var url = '#/uye/index'
        setTimeout(function () {
          window.open(url, '_self')
        }.bind(this), 5000)
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserManageUpdate'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserManageUpdate'
        this.snackbar = true
      }
    })

  }
</script>